'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Api = require('@teko/api');
var auth = require('@teko/auth');
var error = require('./error.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var Api__default = /*#__PURE__*/_interopDefaultLegacy(Api);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const LS_CART_TOKEN = "cart_token";
const cartTokenHeader = "x-cart-token";
const getCartToken = (localStorageKey) => localStorage.getItem(localStorageKey);
const setCartToken = (token, localStorageKey = LS_CART_TOKEN) => localStorage.setItem(localStorageKey, token);
const defaultCartValue = {
  id: "",
  grandTotal: 0,
  orderCoupons: {
    applicableCoupons: [],
    inapplicableCoupons: []
  },
  orderLines: [],
  promotions: [],
  shippingFee: 0,
  subTotal: 0,
  totalDiscount: 0,
  eVouchers: [],
  allowToRequestOnDemandDiscount: false
};
const parseJWT = (token) => {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(atob(base64).split("").map(function(c) {
      return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(""));
    return JSON.parse(jsonPayload)["cid"];
  } catch (e) {
    return null;
  }
};
class CartService {
  constructor(cartApiUrl, localStorageKey = LS_CART_TOKEN, language, options) {
    this.getCart = async (params) => {
      const cartToken = getCartToken(this.localStorageKey);
      const accessToken = auth.getAccessToken();
      return !cartToken && !accessToken ? Promise.resolve(defaultCartValue) : this.cartApi.get("/api/v1/cart", { params: __spreadValues({}, params) }).then(({ data }) => data.result);
    };
    this.addToCart = async (params, body) => {
      const { data, headers } = await this.cartApi.post("api/v1/cart/add-to-cart", body, { params: __spreadValues({}, params) });
      const token = headers[cartTokenHeader];
      if (!!token) {
        localStorage.setItem(this.localStorageKey, token);
      }
      return __spreadProps(__spreadValues({}, data.result), { cartId: parseJWT(token) });
    };
    this.applyCoupon = async (params, body) => {
      const { data } = await this.cartApi.post("api/v1/cart/apply-coupon", body, {
        params: __spreadValues({}, params)
      });
      return data.result;
    };
    this.removeCoupon = (params, body) => {
      return this.cartApi.delete("api/v1/cart/clear-coupon", body, { params: __spreadValues({}, params) });
    };
    this.clearCart = (params) => {
      return this.cartApi.delete("api/v1/cart", null, {
        params: __spreadValues({}, params)
      });
    };
    this.updateOrderLine = async (params, id, body) => {
      return this.cartApi.put(`api/v1/cart/order-lines/${id}`, body, {
        params: __spreadProps(__spreadValues({}, params), { graceful: true })
      }).then(({ data }) => Promise.resolve(data.result));
    };
    this.updateSellerItems = (params, sellerId, selected) => {
      return this.cartApi.put("api/v1/cart/order-items", { selected }, { params: __spreadProps(__spreadValues({}, params), { sellerId }) });
    };
    this.removeOrderLine = async (params, id) => {
      return (await this.cartApi.delete)(`api/v1/cart/order-lines/${id}`, null, {
        params: __spreadValues({}, params)
      });
    };
    this.setShippingAddress = (params, selectedAddress) => {
      const fullAddress = [
        selectedAddress.address,
        selectedAddress.wardName,
        selectedAddress.districtName,
        selectedAddress.provinceName
      ].filter(Boolean).join(", ");
      const infoSetShippingAddr = __spreadProps(__spreadValues({
        addressId: selectedAddress.addressId || selectedAddress.id,
        wardCode: (selectedAddress == null ? void 0 : selectedAddress.wardCode) || "",
        districtCode: selectedAddress == null ? void 0 : selectedAddress.districtCode,
        provinceCode: selectedAddress == null ? void 0 : selectedAddress.provinceCode,
        wardName: (selectedAddress == null ? void 0 : selectedAddress.wardName) || "",
        districtName: selectedAddress == null ? void 0 : selectedAddress.districtName,
        provinceName: selectedAddress == null ? void 0 : selectedAddress.provinceName,
        address: selectedAddress == null ? void 0 : selectedAddress.address,
        name: selectedAddress == null ? void 0 : selectedAddress.name
      }, (selectedAddress == null ? void 0 : selectedAddress.email) && { email: selectedAddress.email }), {
        telephone: selectedAddress == null ? void 0 : selectedAddress.telephone,
        addressNote: "",
        fullAddress: selectedAddress.fullAddress || fullAddress
      });
      return this.cartApi.post(`api/v1/cart/shipping-address`, infoSetShippingAddr, { params: __spreadValues({}, params) });
    };
    this.getPaymentMethod = async (params, orderCode) => {
      const { data } = await this.cartApi.get("api/v1/cart/payment-methods-v2", {
        params: __spreadValues(__spreadValues({}, params), orderCode ? { orderCode } : {})
      });
      return data.result;
    };
    this.checkout = async (params, body) => {
      var _a, _b, _c, _d;
      const { data } = await this.cartApi.post("api/v1/cart/checkout", body, {
        params: __spreadValues({}, params)
      });
      return __spreadProps(__spreadValues({}, data.result), {
        orderId: ((_a = data.result) == null ? void 0 : _a.orderIdString) || ((_b = data.result) == null ? void 0 : _b.orderId),
        id: ((_c = data.result) == null ? void 0 : _c.orderIdString) || ((_d = data.result) == null ? void 0 : _d.orderId),
        get remainPayment() {
          return parseFloat(data.result.grandTotal.toString()) - data.result.totalPaid;
        }
      });
    };
    this.getOrderByCode = async (params, code) => {
      const { data } = await this.cartApi.get(`/api/v1/orders/${code}`, {
        params: __spreadValues({}, params)
      });
      const order = data.result;
      return __spreadProps(__spreadValues({}, order), {
        orderId: (order == null ? void 0 : order.idString) || (order == null ? void 0 : order.id),
        id: (order == null ? void 0 : order.idString) || (order == null ? void 0 : order.id),
        grandTotal: parseInt(order.grandTotal),
        get remainPayment() {
          var _a;
          const prevPayment = ((_a = order == null ? void 0 : order.payments) == null ? void 0 : _a.reduce((amount, currentPayment) => amount + currentPayment.amount, 0)) || 0;
          return parseFloat(order.grandTotal.toString()) - prevPayment;
        }
      });
    };
    this.getApplicableServices = async (params) => {
      const { data } = await this.cartApi.get("api/v1/cart/applicable-services", {
        params: __spreadValues({}, params)
      });
      return data.result;
    };
    this.findApplicableServices = async (params, body) => {
      const { data } = await this.cartApi.post("/api/v1/cart/applicable-services", body, {
        params: __spreadValues({}, params)
      });
      return data.result;
    };
    this.getDeliveryOptions = async (params, body) => {
      const { data } = await this.cartApi.post("/api/v1/cart/delivery-options", body, {
        params: __spreadValues({}, params)
      });
      return data.result;
    };
    this.applyServiceToCart = async (params, body) => {
      const { data } = await this.cartApi.put("/api/v1/cart/apply-service", body, { params: __spreadValues({}, params) });
      return data.result;
    };
    this.applyPaymentMethodToCart = async (params, body) => {
      const { data } = await this.cartApi.put("/api/v1/cart/apply-payment-method", body, { params: __spreadValues({}, params) });
      return data.result;
    };
    this.importOrder = async (payload, query) => {
      const { data } = await this.cartApi.post("/api/v1/orders", payload, {
        params: __spreadValues({}, query)
      });
      return data.result;
    };
    this.cartApi = new Api__default["default"](cartApiUrl, error.getError);
    this.localStorageKey = localStorageKey;
    if (typeof (options == null ? void 0 : options.getCustomAccessToken) === "function") {
      this.cartApi.addInterceptor((request) => {
        var _a;
        request.headers.set("Authorization", `Bearer ${(_a = options.getCustomAccessToken) == null ? void 0 : _a.call(options)}`);
      });
    } else {
      this.cartApi.addInterceptor(auth.accessTokenInterceptor);
    }
    this.cartApi.addInterceptor((request) => {
      var _a;
      if (typeof window === "undefined" && !(options == null ? void 0 : options.isSyncCartOffline))
        return;
      if (options == null ? void 0 : options.cartToken) {
        request.headers.set(cartTokenHeader, options == null ? void 0 : options.cartToken);
      } else {
        const cartToken = ((_a = this.getCartToken) != null ? _a : getCartToken)(localStorageKey);
        if (cartToken) {
          request.headers.set(cartTokenHeader, cartToken);
        }
      }
    });
    this.cartApi.addInterceptor((request) => {
      request.headers.set("Accept-Language", language || "*");
    });
    this.cartApi.addResponseInterceptor(auth.handleResponseUnauthorizedInterceptor);
  }
  setParams({ getCartToken: getCartToken2 }) {
    this.getCartToken = getCartToken2;
  }
}

exports.CartService = CartService;
exports.defaultCartValue = defaultCartValue;
exports.parseJWT = parseJWT;
exports.setCartToken = setCartToken;
